import React from "react";
import AddTransfer from "../../../AddsEdits/Student/AddTransfer.js";

export default function AddTransferDialog({
  open,
  onClose,
  transferDate,
  direction,
  studentId,
  adultId,
  personType = "STUDENT",
  campuses = [],
  onSaved,
}) {
  const isAdult =
    String(personType || "").toUpperCase() === "ADULT" ||
    (adultId && Number(adultId) !== 0);

  const target = isAdult
    ? { personType: "ADULT", adultId: Number(adultId) }
    : { personType: "STUDENT", studentId: Number(studentId) };

  return (
    <AddTransfer
      open={open}
      onClose={onClose}
      hideTrigger
      transferDate={transferDate}
      direction={direction}
      passedStudent={isAdult ? null : studentId}
      isAdult={isAdult}
      adultId={isAdult ? Number(adultId) : undefined}
      campuses={campuses}
      addTransfer={async (payload /*, sid */) => {
        await onSaved?.(payload, target);
      }}
    />
  );
}
